import { useMemo } from "react";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useIsDealerGroup } from "../blocks/DealerGroup/useIsDealerGroup";
import { useDealerId } from "../stores/hooks/useDealerId";
import { useNationalAccountId } from "../stores/hooks/useNationalAccountId";
import { useSearchForm } from "../stores/hooks/useSearchForm";
import { ComboBoxOption } from "../ui/ComboBox/useComboBox";

type Option = ComboBoxOption<number>;

export const useGetVehicleYears = (): ModifiedSWRResponse<
  FetcherResult<Payload>,
  Option[]
> & {
  vehicleYearId?: number;
} => {
  const [{ dealerId, vehicleYear }] = useSearchForm();
  const nationalAccountId = useNationalAccountId();
  const selectedDealerId = useDealerId();
  const isDealerGroup = useIsDealerGroup();

  const shouldFetch = isDealerGroup ? Boolean(dealerId) : true;

  const { data, ...res } = useSwrGet<Payload>(
    shouldFetch ? "/retailSiteWebService/vehicle/getVehicleYears.php" : null,
    {
      dealerId: selectedDealerId,
      nationalAccountId,
    }
  );

  const options = useMemo(() => {
    if (!data) return undefined;
    return Object.entries(data as unknown as Payload)
      .map<Option>(([value, label]) => ({
        data: null,
        label: String(label),
        value: Number(value),
      }))
      .reverse();
  }, [data]);

  const vehicleYearId = options?.find(
    ({ label }) => label === vehicleYear
  )?.value;

  return {
    ...res,
    data: options,
    vehicleYearId,
  };
};

type Payload = {
  [key: string]: number;
};
